module.exports = __webpack_public_path__ + "assets/img/h1.fb13bc0d.png";